import { getCommonStyle } from './styleCommon';
import canvasEnums from '../enums/canvas';

export function getMarkerStyles() {

	const bandBackgroundColor = getCommonStyle('color.band.background');
	const bandLineColor = getCommonStyle('color.band.line');
	const fontFamily = getCommonStyle('font.family');

	return {
		band: {
			background: {
				color: bandBackgroundColor
			},
			color: bandLineColor,
			label: {
				color: '#888',
				font: {
					family: fontFamily,
					size: 11,
					weight: 'normal'
				},
				padding: {
					left: 5,
					right: 5
				},
				textAlign: canvasEnums.textAlign.LEFT
			},
			lineDash: '',
			width: 1
		},
		extendedHours: {
			color: 'rgba(255, 255, 255, 0.3)',
			preMarket: {
				background: {
					color: 'rgba(155, 155, 155, 0.15)'
				},
				// Middle line
				startLine: {
					color: null,
					width: null
				},
				// Right line
				stopLine: {
					color: null,
					width: null
				}
			},
			postMarket: {
				background: {
					color: 'rgba(155, 255, 255, 0.1)'
				},
				// Left line
				startLine: {
					color: null,
					width: null
				}
			},
			width: 1
		}
	};
}
